module.exports = __webpack_public_path__ + "static/media/fairy_3.82479ea1.jpg";